module.exports = __webpack_public_path__ + "img/banner.1d17b95.png";